export function XML_Cmd(theCmd, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputSimpleElement("cm", theCmd, s);
}
